import type { RewardConditionProgressData } from '@/schemas/v2/user'
import type { TFunction } from 'i18next'

/**
 * 1件の条件進捗データの表示名を解決する。
 * displayName が無く、種別からも既定文言が決まらない場合は null を返す
 * （呼び出し側は進捗の数値だけを表示する）。
 */
export function resolveConditionLabel(t: TFunction, condition: RewardConditionProgressData): string | null {
  const { type, displayName } = condition
  return (
    displayName ??
    (type === 'STAMP_COUNT'
      ? t('reward_detail.condition_stamp_status', 'スタンプ獲得状況')
      : type === 'POINT_SUM'
        ? t('common.point', 'ポイント')
        : null)
  )
}

/** 1件の条件進捗データをテキストに変換する */
export function resolveConditionText(t: TFunction, condition: RewardConditionProgressData): string {
  const { current, threshold } = condition
  const label = resolveConditionLabel(t, condition)
  return label ? `${label} ${current}/${threshold}` : `${current}/${threshold}`
}

/** 条件進捗データの配列をテキスト配列に変換する（CONDITION_GROUP は除外） */
export function resolveProgressTexts(t: TFunction, conditions: RewardConditionProgressData[]): string[] {
  return conditions.filter((c) => c.type !== 'CONDITION_GROUP').map((c) => resolveConditionText(t, c))
}
